export enum CompanionStatusType {
  active = 'active',
  pending = 'pending',
  blocked = 'blocked',
  received = 'received',
}
